import { useMutation } from '@apollo/client';

import { useCancellablePromise } from '../../../../../../../hooks/use-cancellable-promise/use-cancellable-promise';
import { useActionsInProgress } from '../../../../../../../graphql/preloader/actions/actions-in-progress';
import { promiseErrorCallbacks } from '../../../../../../../utils/promise/set-promise-error-callbacks';
import { CancelOrderModalProps } from './order-cancel-notification-modal.models';
import { UPDATE_NC_NOTIFICATION } from '../../../../../../../graphql/notifications/mutations/update-nc-notification';
import { OrderCancelNotificationModal as OrderCancelNotificationModalView } from './order-cancel-notification-modal';
import { setOrderNumber } from '../../../../../../../graphql/order/order.cache';

export const OrderCancelModal = ({
  orderNumber, notificationId, onCreate, onDetails, onClose, ...props
}: CancelOrderModalProps): JSX.Element => {
  const [updateNotification] = useMutation(UPDATE_NC_NOTIFICATION);
  const { addActionInProgress, removeActionInProgress } = useActionsInProgress();
  const {
    makeCancellablePromise,
    CancelledPromiseOnUnmountError,
  } = useCancellablePromise();

  const handleModalClose = async () => {
    try {
      addActionInProgress();

      await makeCancellablePromise(
        updateNotification({
          variables: {
            notificationId,
          },
        }),
      );
    } catch (error) {
      if (error instanceof CancelledPromiseOnUnmountError) {
        return;
      }

      if (promiseErrorCallbacks.anyError) {
        promiseErrorCallbacks.anyError();
      }
    } finally {
      removeActionInProgress();
      onClose!();
    }
  };

  const handleCreate = () => {
    handleModalClose();
    onCreate();
  };

  const handleDetails = () => {
    handleModalClose();
    onDetails();
    setOrderNumber(orderNumber);
  };

  return (
    <OrderCancelNotificationModalView
      {...props}
      onClose={handleModalClose}
      onCreate={handleCreate}
      onDetails={handleDetails}
      orderNumber={orderNumber}
    />
  );
};
